import { useState } from "react";
import { createPortal } from "react-dom";
import { database } from "../../../lib/supabase";
import { useAuth } from "../../../modules/authentication/AuthProvider";
import { Button, Modal, Textarea } from "react-daisyui";
import { useTranslation } from 'react-i18next';

const FeedbackDialog: React.FC<{ currentPage: string, buttonTitle?: string, buttonSize?: 'sm' | 'md' | 'lg', buttonColor?: 'primary' | 'secondary' | 'ghost' }> = ({ currentPage, buttonTitle, buttonSize = 'sm', buttonColor = 'primary' }) => {
    const { currentUser } = useAuth();
    const [feedback, setFeedback] = useState('');
    const [showThankYou, setShowThankYou] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const handleSubmit = async () => {
        if (!currentUser || !feedback.trim()) return;

        try {
            const { data, error } = await database.userFeedback.table()
                .insert({
                    user_id: currentUser.id,
                    feedback: feedback.trim(),
                    current_page: currentPage
                });

            if (error) throw error;

            setFeedback('');
            setShowThankYou(true);
            setTimeout(() => {
                setShowThankYou(false);
                setIsOpen(false);
            }, 3000);
        } catch (error) {
            console.error('Error submitting feedback:', error);
        }
    };

    return (
        <>
            <Button size={buttonSize ?? "sm"} color={buttonColor ?? "primary"} onClick={() => setIsOpen(true)} data-umami-event="Feedback Dialog Open">
                {buttonTitle ?? t('components.feedbackDialog.button')}
            </Button>
            {createPortal(
                <Modal open={isOpen}>
                    <Modal.Header className="font-bold">{t('components.feedbackDialog.title')}</Modal.Header>
                    <Modal.Body>
                        <p className="py-4">{t('components.feedbackDialog.description')}</p>
                        {!showThankYou ? (
                            <>
                                <div className="form-control">
                                    <label className="label">
                                        <span className="label-text">{t('components.feedbackDialog.messageLabel')}</span>
                                    </label>
                                    <Textarea 
                                        className="h-24" 
                                        placeholder={t('components.feedbackDialog.placeholder')}
                                        value={feedback}
                                        onChange={(e) => setFeedback(e.target.value)}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="py-4">
                                <p className="text-success">{t('components.feedbackDialog.thankYou')}</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Actions>
                        {!showThankYou && (
                            <>
                                <Button color="ghost" onClick={() => setIsOpen(false)}>{t('components.feedbackDialog.cancel')}</Button>
                                <Button color="primary" onClick={handleSubmit}>{t('components.feedbackDialog.submit')}</Button>
                            </>
                        )}
                    </Modal.Actions>
                </Modal>,
                document.body
            )}
        </>
    );
};

export default FeedbackDialog;
